<template>
	<div class="xs-12">
		<!-- Headline -->
		<div class="flex xs-12 xs-between">
			<div class="fs5 lh125 fw7 c1 mb2">
				{{ $t("others") }}
			</div>
			<j-button v-if="canEditApprovedClaims(claim.status)" type="tertiary" @click="$modal.show('updateCodes')">
				<crm-icon name="edit" color="c2" size="small" />
				{{ $t("update") }}
			</j-button>
		</div>

		<!-- Data -->
		<j-card class="bg5 p4">
			<!-- Diagnosis Code -->
			<div class="fs3 c6 fw7 mb1 ">{{ $t("diagnosis_code") }}</div>
			<div v-for="item in computedDiagnosisCodes" class="mb1 r2 p1 bg7--l3">
				<div class="lh125">{{ item.code }} - {{ item.name }}</div>
				<div class="lh125 c6">{{ item.description }}</div>
			</div>

			<!-- Operation Code -->
			<div class="fs3 c6 fw7 mb1 mt4">{{ $t("operation_code") }}</div>
			<div v-for="item in computedOperationCodes" class="mb1 r2 p1 bg7--l3">
				<div class="lh125">{{ item.code }} - {{ item.name }}</div>
				<div class="lh125 c6">{{ item.description }}</div>
			</div>

			<!-- Provider -->
			<div class="fs3 c6 fw7 mb1 mt4">{{ $t("provider_code") }}</div>
			<div class="mb1 r2 p1 bg7--l3" v-if="computedProvider">
				<div class="lh125">
					{{ computedProvider.internalCode }} - {{ computedProvider.name }}
				</div>
			</div>
		</j-card>

		<!-- Modal -->
		<core-modal name="updateCodes" :headline="$t('update')">
			<update-codes
				style="min-height:450px;"
				:productId="computedProductId"
				:claimId="claim.id"
				:data="claim"
				@updated="$emit('updated')"
			/>
		</core-modal>
	</div>
</template>

<script>
import UpdateCodes from "./UpdateCodes"
import CoreModal from "@/modules/core/components/CoreModal"
import CrmIcon from "@/components/CrmIcon"
import JButton from "@/components/JButton"
import JCard from "@/components/JCard"
import JList from "@/components/JList"
import JTag from "@/components/JTag/"
import { canEditApprovedClaims } from "../utils/"

export default {
	components: {
		UpdateCodes,
		CoreModal,
		CrmIcon,
		JButton,
		JCard,
		JList,
		JTag
	},
	props: {
		claim: {
			required: true
		}
  },
  methods: {
    canEditApprovedClaims: canEditApprovedClaims
  },
	computed: {
		computedProductId() {
			return this.claim?.policy?.acceptedOffer?.product?.productId || {}
		},
		computedOperationCodes() {
			return this.claim?.operationCodes || []
		},
		computedDiagnosisCodes() {
			return this.claim?.diagnosisCodes || []
		},
		computedProvider() {
			return this.claim?.provider || null
    }
	}
}
</script>
